// extracted by mini-css-extract-plugin
export default {"guideOverlay":"index_guideOverlay__AkrwV","guideImage":"index_guideImage__eTn-u"};